import $ from 'jquery';
import './tooltip.scss';

export default function () {
    const MOBILE_LAYOUT = 'Mobile';
    if (vendor.pageInfo.getLayout() === MOBILE_LAYOUT) {
        let $window = $(window);
        let $body = $('body');
        let currentScrollTop;

        const closeTooltipHandler = function () {
            $('.product-model-tooltip-window.product-model-tooltip-window-open').removeClass('product-model-tooltip-window-open');
            $('.product-model-tooltip-window-background').off('click', closeTooltipHandler).remove();
            $body.removeClass('product-model-tooltip-window-open').css({top: ''});
            $window.scrollTop(currentScrollTop);
        };

        const openTooltipHandler = function () {
            $(this).closest('.product-model-tooltip').find('.product-model-tooltip-window').addClass('product-model-tooltip-window-open');
            $body.append($('<div class="product-model-tooltip-window-background"></div>').on('click', closeTooltipHandler));
            currentScrollTop = window.pageYOffset;
            $body.addClass('product-model-tooltip-window-open').css({top: `-${currentScrollTop}px`});
        };

        $('.product-model-tooltip .crux-icons-help-information').on('click', openTooltipHandler);
        $('.product-model-tooltip .crux-icons-close').on('click', closeTooltipHandler);
    }
};



// WEBPACK FOOTER //
// ./resources/modules/shared/components/Tooltip/index.js